// useEnumStore.ts
import { defineStore } from 'pinia';
import { CustomerProfileLookupDto, TicketFareStateEnum } from '@/api';
import { EnumDto } from '@ui-kit';
import ticketFareStateService from '@/services/api/ticketFareStateService.ts';
import customerProfileService from '@/services/api/customerProfileService.ts';
import cardStateService from '@/services/api/cardStateService.ts';

export const useEnumStore = defineStore('enum', {
  state: () => ({
    ticketFareStates: null as TicketFareStateEnum[] | null,
    customerProfiles: undefined as CustomerProfileLookupDto[] | undefined,
    cardStates: null as EnumDto[] | null,
  }),
  actions: {
    async getTicketFareStates() {
      if (!this.ticketFareStates) {
        this.ticketFareStates = await ticketFareStateService.getTicketFareStateList();
      }
      return this.ticketFareStates;
    },
    async getCustomerProfiles() {
      if (!this.customerProfiles) {
        this.customerProfiles = await customerProfileService.getCustomerProfileListLookup();
      }
      return this.customerProfiles;
    },
    async getCardStates() {
      if (!this.cardStates) {
        this.cardStates = await cardStateService.getCardStateList();
      }
      return this.cardStates;
    },
    clearEnums() {
      this.ticketFareStates = null;
      this.customerProfiles = undefined;
      this.cardStates = null;
    },
  },
});
